import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

const message = 'Signing up is currently disabled, use discord to sign in';

export const DisabledSignupButton = ({ testId, className = '', tab = false }) => <TooltipProvider delayDuration={150}><Tooltip>
  <TooltipTrigger asChild><button type="button" className={`auth-signup-disabled ${className}`} data-testid={testId}
    aria-disabled="true" aria-describedby={`${testId}-description`} role={tab ? 'tab' : undefined} aria-selected={tab ? false : undefined}
    onClick={(event) => event.preventDefault()} onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') event.preventDefault();
      if (tab && event.key === 'ArrowRight') { event.preventDefault(); document.querySelector('[data-testid="auth-login-tab"]')?.focus(); }
    }}>Sign Up</button></TooltipTrigger>
  <span className="sr-only" id={`${testId}-description`} data-testid={`${testId}-description`}>{message}</span>
  <TooltipContent className="auth-signup-disabled-tooltip" data-testid={`${testId}-tooltip`} side="bottom" sideOffset={8} collisionPadding={16}>{message}</TooltipContent>
</Tooltip></TooltipProvider>;